
    <!--
 * 横版-签到领奖
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_PU3219"  :class="[`normal sign-page`,`u_c_PU3219`]" ><div id="u_c_4XT324"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_4XT324`]" ></div><div id="u_c_FWNF17"  v-html="compData.subTitle" :class="[`normal`,`u_c_FWNF17`]" ></div><div id="u_c_PHXH28"  :class="[`normal`,`u_c_PHXH28`]" ><span id="u_c_EHIZ29"  :class="[`normal txt`,`u_c_EHIZ29`]" >{{`${ langData.mySignTime }:`}}</span><span id="u_c_U3DG31"  :class="[`normal txt sign-total-day`,`u_c_U3DG31`]" >{{`${ pageData.signTime }`}}</span><span id="u_c_V2CG35"  :class="[`normal txt`,`u_c_V2CG35`]" >{{`${ langData.day }`}}</span></div><div id="u_c_IA8J17"  :class="[`normal`,`u_c_IA8J17`]" ><div id="u_c_MNBL18"  v-for="(signItem, signIndex) in compData.signInfo" :key="signIndex" :data-index="signItem.day" :class="[`normal sign-item btn-light award-btn`,`u_c_MNBL18`]" @click="u_c_MNBL18_event_W81W61($event,signIndex)"><div id="u_c_156W17"  :class="[`normal `,`u_c_156W17`]" ><span id="u_c_A2HQ25"  v-html="signItem.day" :class="[`normal sign-day`,`u_c_A2HQ25`]" ></span>{{`${ langData.day }`}}</div><div id="u_c_W7BU19"  :style="`background-image:url(${ signItem.pic })`" :class="[`u_c_W7BU19_${signIndex}`,`normal sign-img`,`u_c_W7BU19`]" ></div><div id="u_c_1TRJ20"  v-show="signItem.state == 2 || signItem.state == void 0 && signIndex == 0" :class="[`normal gou`,`u_c_1TRJ20`]" ></div></div></div><a id="u_c_S2XY22" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light  sign-award-btn`,`u_c_S2XY22`]" @click="u_c_S2XY22_event_8J5W26($event)"><div id="u_c_S2S020"  :class="[`normal page-common-btn`,`u_c_S2S020`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"signInfo":[{"name":"签到第1个奖励\n签到第1-1个奖励\n签到第1-2个奖励\n签到第1-3个奖励","day":"1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607104.png"},{"name":"签到第2个奖励","day":"2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960122.png"},{"name":"签到第3个奖励","day":"3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607890.png"},{"name":"签到第4个奖励","day":"4","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609844.png"},{"name":"签到第5个奖励","day":"5","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609538.png"},{"name":"签到第6个奖励","day":"6","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960221.png"},{"name":"签到第7个奖励","day":"7","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png"}],"subTitle":`累计签到达到以下次数，可领取活动奖励`,"title":`九考特训
签到送好礼`},"en-US":{"signInfo":[{"name":"Solo Boss Entry Ticket*2\nHourglass*1\nReputation (500)*1\nJewel of Life*3","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192765405347.png"},{"name":"Blood Castle Entry Ticket*2\nBreath of the Divine Wind (Advanced)*3\nCriticality Stone(Intermediate)*5\nGarnet Jewel*50","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192724564013.png"},{"name":"Scallop Flesh*1\nJewel of Moonlight*2\nReputation (1000)*1\nJewel of Life*5","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192762379073.png"},{"name":"Dragon Orbs (Unique)*1\nRed Foliage*2\nIntermediate Benediction*1\nGarnet Jewel*100","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192781996856.png"}],"subTitle":`Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.`,"title":`Daily Sign-in Reward`},"ru-RU":{"signInfo":[{"name":"Билет на вход к Одиночному Боссу*2\nПесочные часы*1\nРепутация (500)*1\nСамоцвет Жизни*3","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192765405347.png"},{"name":"Билет на вход в Кровавый Замок*2\nДыхание Божественного Ветра (Усиленное)*3\nКамень Критического Удара (Средний)*5\nСамоцвет Граната*50","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192724564013.png"},{"name":"Мясо Скалло*1\nСамоцвет Лунного света*2\nРепутация (1000)*1\nСамоцвет Жизни*5","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192762379073.png"},{"name":"Драконьи шары (Уникальные)*1\nКрасная листва*2\nСреднее Благословение*1\nСамоцвет Граната*100","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192781996856.png"}],"subTitle":`Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.`,"title":`Daily Sign-in Reward`},"pt-PT":{"signInfo":[{"name":"Bilhete de Entrada para o Chefe Solo*2\nAmpulheta*1\nReputação (500)*1\nJoia da Vida*3","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192765405347.png"},{"name":"Bilhete de Entrada para o Castelo de Sangue*2\nSopro do Vento Divino (Avançado)*3\nPedra de Criticidade (Intermediária)*5\nJoia de Granada*50","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192724564013.png"},{"name":"Carne de Scallo*1\nJoia do Luar*2\nReputação (1000)*1\nJoia da Vida*5","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192762379073.png"},{"name":"Orbes de Dragão (Único)*1\nFolhagem Vermelha*2\nBênção Intermediária*1\nJoia de Granada*100","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192781996856.png"}],"subTitle":`Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.`,"title":`Daily Sign-in Reward`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '签到领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform

const init = () => {
  compData.signInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.signList) {
      let confList = _.cloneDeep(compData.signInfo)
      compData.signInfo = []
      value.signList.forEach((item, index) => {
        if (confList[index]) {
          compData.signInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            day: item.sign_day,
            name: confList[index].name
          })
        }
      })
      giftInfo.signInAward = compData.signInfo
    }
  }, {
    deep: true
  }
)

init()

const canClickSign = ref(true)
const signDay = async (day, index) => {

  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'signInAward'), {
    params: JSON.stringify({
      sign_day: +day,
      language: curLang
    }),
  })
  if (res.result == 1) {
    compData.signInfo[index].state = 2;
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value : compData.signInfo[index].name;
    showGetSucc(res.data.send_type, compData.signInfo[index].pic, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
};
      // 签到item的click事件
      const u_c_MNBL18_event_W81W61= async (e,index)=>{
        try {pageData.seeGift = [compData.signInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 签到可领按钮的click事件
      const u_c_S2XY22_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickSign.value) return;
canClickSign.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: `领取签到奖励`,
  gameId: pageData.gameId,
  aid: pageData.pageId
});
let curIndex = compData.signInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await signDay(compData.signInfo[curIndex].day, curIndex);
} else {
  let finishIndex = compData.signInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.signInfo.length - 1 ? '-20001' : '-10010',
      getLangTxt('common')
    ),
    ''
  );
}
canClickSign.value = true;} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115647-6.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715378751190.png);
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.default{
.u_c_EHIZ29.normal{
position:relative;

}
}.default{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.default{
.u_c_V2CG35.normal{
position:relative;

}
}.default{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:2.08vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.default{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
width:10.89vw;
height:11.82vw;

}
}.default{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_A2HQ25.normal{
position:relative;

}
}.default{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:7.86vw;
height:5.83vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.default{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.default{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}.en-US{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115647-6.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.en-US{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.en-US{
.u_c_EHIZ29.normal{
position:relative;

}
}.en-US{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.en-US{
.u_c_V2CG35.normal{
position:relative;

}
}.en-US{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:2.08vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.en-US{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
width:10.89vw;
height:11.82vw;

}
}.en-US{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_A2HQ25.normal{
position:relative;

}
}.en-US{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:7.86vw;
height:5.83vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.en-US{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.en-US{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}.ru-RU{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115647-6.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ru-RU{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ru-RU{
.u_c_EHIZ29.normal{
position:relative;

}
}.ru-RU{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.ru-RU{
.u_c_V2CG35.normal{
position:relative;

}
}.ru-RU{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:2.08vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.ru-RU{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
width:10.89vw;
height:11.82vw;

}
}.ru-RU{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_A2HQ25.normal{
position:relative;

}
}.ru-RU{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:7.86vw;
height:5.83vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.ru-RU{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.ru-RU{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.ru-RU{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}.pt-PT{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115647-6.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pt-PT{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.pt-PT{
.u_c_EHIZ29.normal{
position:relative;

}
}.pt-PT{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.pt-PT{
.u_c_V2CG35.normal{
position:relative;

}
}.pt-PT{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:2.08vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.pt-PT{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116103-97.png);
background-size:contain;
width:10.89vw;
height:11.82vw;

}
}.pt-PT{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_A2HQ25.normal{
position:relative;

}
}.pt-PT{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:7.86vw;
height:5.83vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.pt-PT{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.pt-PT{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:21.56vw;
height:7.40vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.pt-PT{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}
</style>
